import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('fieldSelectPanelField');

    return {
        NO_FIELDS_FOUND: t('noFieldsFound'),
        SEARCH: t('search'),
        SELECT_A_FARM_TO_SEE_FIELDS: t('selectAFarmToSeeFields')
    };
};

export default useTranslation;
